import Request from './request';
import { getHeaders } from './requestHelpers';

const Paths = {
  SUBSCRIPTION_PRODUCTS_ADD: 'addProducts',
  SUBSCRIPTION_OPTIONS_VALIDITY: 'optionsValidity',
  SUBSCRIPTION_OPTIONS_ADD: 'addOptions',
  SUBSCRIPTION_OPTIONS_REMOVE: 'removeOptions',
  SUBSCRIPTION_OPTIONS_HISTORY: 'listOptions',
  SUBSCRIPTION_AVAILABLE_OPTIONS: 'availableOffers',
};

/**
 * Add one or multiple products
 * @param {Object} params
 * @param {Array} params.productIds - Array of product ids, ex. [1]
 * @param {String} authToken -  user security token
 * @return {Promise}
 */
export async function productsAdd(params, authToken) {
  const { status, result, error } = await Request({
    method: 'POST',
    headers: getHeaders(authToken),
    data: params,
    path: Paths.SUBSCRIPTION_PRODUCTS_ADD,
  });

  return status ? Promise.resolve(result) : Promise.reject(error);
}


/**
 * Returns a list of available offers
 * @param {String} params.languageId
 * @return {Promise}
 */
export async function fetchAvailableOptions(params) {
  const { status, result, error } = await Request({
    method: 'POST',
    headers: { 'X-AN-WebService-Version': 2 },
    data: params,
    path: Paths.SUBSCRIPTION_AVAILABLE_OPTIONS,
  });

  return status ? Promise.resolve(result.options) : Promise.reject(error);
}

/**
 * Returns a list containing validity informations of options
 * @param {Object} params
 * @param {Number} params.productId - id of product, ex. 1
 * @param {String} authToken -  user security token
 * @return {Promise}
 */
export async function checkOptionsValidity(params, authToken) {
  const { status, result, error } = await Request({
    method: 'POST',
    headers: getHeaders(authToken),
    data: params,
    path: Paths.SUBSCRIPTION_OPTIONS_VALIDITY,
  });

  return status ? Promise.resolve(result.options) : Promise.reject(error);
}

/**
 * Returns a list containing history information about user options
 * @param {Object} params
 * @param {Number} params.productId - id of product, ex. 1
 * @param {String} params.languageId - selected language Id
 * @param {String} authToken -  user security token
 * @return {Promise}
 */
export async function fetchOptionsHistory(params, authToken) {
  const { status, result, error } = await Request({
    method: 'POST',
    headers: getHeaders(authToken),
    data: params,
    path: Paths.SUBSCRIPTION_OPTIONS_HISTORY,
  });

  return status ? Promise.resolve(result.options) : Promise.reject(error);
}

/**
 * Subscribe: Add option to user subscriptions
 * @param {Object} params
 * @param {Array} params.optionIds - array of option ids, ex. [19]
 * @param {number} params.productId - id of product, ex. 1
 * @param {String} authToken -  user security token
 * @return {Promise}
 */
export async function optionsAdd(params, authToken) {
  const { status, result, error } = await Request({
    method: 'POST',
    headers: getHeaders(authToken),
    data: params,
    path: Paths.SUBSCRIPTION_OPTIONS_ADD,
  });

  return status ? Promise.resolve(result) : Promise.reject(error);
}

/**
 * Subscribe: remove option from user subscriptions
 * @param {Object} params
 * @param {Array} params.optionIds -  list of option ids to apply change to (according listOptions), ex. [19]
 * @param {number} params.productId -  if provided, only manage the options related to this product, ex. 1
 * @param {number} params.saleOptionId - option sale Id
 * @param {boolean} params.idReason - the reason of removal {{reasonId}}
 * @param {String} authToken -  user security token
 * @return {Promise}
 */
export async function optionsRemove(params, authToken) {
  const { status, result, error } = await Request({
    method: 'POST',
    headers: getHeaders(authToken),
    params,
    path: Paths.SUBSCRIPTION_OPTIONS_REMOVE,
  });

  return status ? Promise.resolve(result) : Promise.reject(error);
}
